module.exports = __webpack_public_path__ + "static/media/microWhite.61d000e2.png";